export const FORM_ERROR_MAPPING: Record<string, string> = {
  required: 'Required field.',
  invalid: 'Invalid response.',
};
